// import DS from '../../services/dashboardService'
import { graphic } from 'echarts'

export const listMonth = state => val => {
  let months = [
    'SM',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  let month = state.month
  month = []

  for (let index = 0; index < months.length; index++) {
    let dis = false

    if (index < val.emonth && val.eyear == val.ryear) dis = true

    if (index > 0 && index < 10)
      month.push({
        id: index,
        label: months[index],
        isDisabled: dis
      })
    else if (index > 9)
      month.push({
        id: index,
        label: months[index],
        isDisabled: dis
      })
  }

  return month
}

export const listYear = state => val => {
  let year = state.year
  year = []

  let y = val

  for (let index = 0; index < 3; index++) {
    year.push({
      id: y - index,
      label: y - index
    })
  }

  return year.sort((a, b) => a.id - b.id)
}

export const dWeeklyCount = state => {
  let temp = state.activity.activities
  let data = []

  if (Array.isArray(temp) && temp.length) {
    temp.forEach(t => {
      data.push({
        name: t.name,
        weekly: t.weekly
      })
    })

    data.sort((a, b) => b.weekly - a.weekly)
  }
  return data
}

export const dActivityChart = state => {
  // const reducer = (accumulator, curr) => accumulator + curr
  let temp = state.activity.activities
  let datapie = []
  let legendData = []
  let seriesPie = []
  let seriesLine = []
  let final = {}
  let color = ['#005490', '#0077B6', '#48CAE4', '#ADE8F4', '#FFC300', '#F90', '#D27E00', '#379DD2']

  let multiplied = Math.random() * 5
  let floor = Math.floor(multiplied)

  if (Array.isArray(temp) && temp.length)
    for (let i = 0; i < temp.length; i++) {
      let model = temp[i]
      let sum = 0

      model.dayVal.forEach(k => {
        sum += k
      })

      datapie.push({
        name: model.name,
        value: sum,
        selected: i == floor ? true : false
      })

      legendData.push(model.name)
      seriesLine.push({
        name: model.name,
        type: 'line',
        data: model.dayVal,
        seriesLayoutBy: 'row',
        emphasis: { focus: 'series' }
        // markLine: {
        //   animation: true,
        //   data: [
        //     {
        //       name: 'average line',
        //       type: 'average'
        //     }
        //   ]
        // }
      })
    }

  seriesPie.push({
    type: 'pie',

    radius: ['70%', '88%'],
    data: datapie,
    selectedMode: true,
    selectOffset: 3,
    labelLine: {
      show: false
    },
    avoidLabelOverlap: false,
    label: {
      show: false,
      position: 'center',
      align: 'center',
      formatter: '{b|{b}}\n{c|{c} ({d}%)}',
      rich: {
        b: {
          fontSize: 16,
          lineHeight: 20,
          fontWeight: 400,
          color: '#8D8D8D'
        },
        c: {
          fontSize: 24,
          fontWeight: 700,
          color: '#404040'
        }
      }
    },
    select: {
      label: {
        show: true,

        formatter: '{b|{b}}\n{c|{c}}',
        align: 'center',
        rich: {
          b: {
            fontSize: 16,
            lineHeight: 20,
            fontWeight: 400,
            color: '#8D8D8D'
          },
          c: {
            fontSize: 24,
            fontWeight: 700,
            color: '#404040'
          }
        }
      }
    }
  })

  final = {
    pie: {
      title: {
        show: false
      },
      legend: { show: false },
      tooltip: {
        show: false
      },
      color: color,
      series: seriesPie
    },
    line: {
      title: {
        show: false
      },
      legend: { orient: 'horizontal', data: legendData },
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },

      color: color,
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: temp && temp.length ? temp[0].days : []
      },
      yAxis: {
        type: 'value'
      },

      series: seriesLine
    }
  }

  return final
}

export const dDatChart = state => {
  let dat = state.activity.daily_types

  return {
    title: {
      show: false
    },
    tooltip: {
      show: false
    },
    legend: {
      show: false
    },
    series: [
      {
        name: 'Permonth',
        type: 'pie',
        radius: ['35%', '52%'],
        label: {
          formatter: '{b|{b}}\n{per|{c} ({d}%)}',
          //   borderColor: '#00000021',
          borderRadius: 5,
          //   borderWidth: 1,
          backgroundColor: 'white',
          shadowColor: '#00000021',
          shadowBlur: 8,
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          padding: [5, 8],
          rich: {
            b: {
              color: '#8D8D8D',
              fontSize: 13,
              lineHeight: 16,
              fontWeight: 300,
              align: 'center'
            },
            per: {
              color: '#007BFF',
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 20,
              align: 'center'
            },
            box: {
              padding: [2, 4]
            }
          }
        },
        data: dat
      }
    ]
  }
}

export const dDaChart = state => {
  let temp = state.activity.daily_activities
  let temps = temp.sort((a, b) => b.value - a.value)
  let da = temps
  let name = []
  let val = []

  if (Array.isArray(da) && da.length)
    da.forEach(d => {
      name.push(d.name)
      val.push(d.value)
    })

  return {
    title: {
      show: false
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      type: 'category',
      data: name,
      axisLabel: { interval: 0, rotate: 32, fontSize: 14 },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      }
    },

    calculable: true,
    grid: {
      bottom: '30%',
      top: '5%',
      left: '4%',
      right: '5%'
    },
    yAxis: {
      type: 'value',
      axisLine: {
        show: false
      }
    },

    series: [
      {
        name: 'This Month',
        type: 'bar',
        data: val,
        barWidth: 20,
        label: {
          fontSize: 14
        },
        showBackground: false,
        itemStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#83bff6' },
            { offset: 0.5, color: '#188df0' },
            { offset: 1, color: '#188df0' }
          ]),
          borderRadius: 2
        },
        emphasis: {
          itemStyle: {
            color: new graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#2378f7' },
              { offset: 0.7, color: '#2378f7' },
              { offset: 1, color: '#83bff6' }
            ]),
            borderRadius: 2
          }
        }
      }
    ]
  }
}

export const advDailyType = state => {
  let temps = state.advance

  let data = []
  let series = {}

  let seriesPie = {}
  let selected = false

  if (Array.isArray(temps) && temps.length) {
    for (let index = 0; index < temps.length; index++) {
      data.push(temps[index].name)

      temps[index].daily_types.forEach(ac => {
        if (series.hasOwnProperty(ac.name)) series[ac.name].data.push(ac.value)
        else
          series[ac.name] = {
            name: ac.name,
            data: [ac.value],
            type: 'bar',
            barGap: 0,
            label: state.advBarOption,
            emphasis: {
              focus: 'series'
            }
          }

        if (seriesPie.hasOwnProperty(ac.name)) seriesPie[ac.name].value += ac.value
        else
          seriesPie[ac.name] = {
            name: ac.name,
            value: ac.value,
            selected: selected ? true : false
          }

        selected = true
      })
    }
  }

  let bars = Object.values(series)
  let pie = Object.values(seriesPie)

  let pieTemp = [
    {
      type: 'pie',

      radius: ['60%', '80%'],
      center: ['16%', '50%'],
      data: pie,
      selectedMode: true,
      selectOffset: 3,
      labelLine: {
        show: false
      },
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
        align: 'center',
        formatter: '{b|{b}}\n{c|{c} ({d}%)}',
        rich: {
          b: {
            fontSize: 16,
            lineHeight: 20,
            fontWeight: 400,
            color: '#8D8D8D'
          },
          c: {
            fontSize: 24,
            fontWeight: 700,
            color: '#404040'
          }
        }
      },
      top: '7%',
      select: {
        label: {
          show: true,
          align: 'center',
          formatter: '{b|{b}}\n{c|{c} ({d}%)}',
          rich: {
            b: {
              fontSize: 16,
              lineHeight: 20,
              fontWeight: 400,
              color: '#8D8D8D'
            },
            c: {
              fontSize: 24,
              fontWeight: 700,
              color: '#404040'
            }
          }
        }
      }
    }
  ]

  let result = pieTemp.concat(bars)

  return {
    title: {
      text: 'Activity Type',
      left: 'left',
      show: false
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{a} <br/>{b} : {c}',
      textStyle: {
        fontSize: 14
      }
    },
    legend: {
      show: true,
      orient: 'horizontal',
      top: 0
    },
    color: [
      '#0077B6',
      '#48CAE4',
      '#ADE8F4',
      '#CAF0F8',
      '#FFE89D',
      '#FFC300',
      '#F90',
      '#D27E00',
      '#379DD2',
      '#005490'
    ],
    grid: { left: '35%', right: '5%' },
    xAxis: {
      type: 'category',
      axisTick: { show: false },
      data: data,
      axisLabel: {
        fontSize: 14
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      }
    },

    yAxis: {
      type: 'value'
    },
    series: result
  }
}

export const advBarAction = state => {
  let temps = state.advance

  let data = []
  let series = {}

  let seriesPie = {}
  let selected = false

  if (Array.isArray(temps) && temps.length) {
    for (let index = 0; index < temps.length; index++) {
      data.push(temps[index].name)

      temps[index].actions.forEach(ac => {
        if (series.hasOwnProperty(ac.name)) series[ac.name].data.push(ac.value)
        else
          series[ac.name] = {
            name: ac.name,
            data: [ac.value],
            type: 'bar',
            barGap: 0,
            label: state.advBarOption,
            emphasis: {
              focus: 'series'
            }
          }

        if (seriesPie.hasOwnProperty(ac.name)) seriesPie[ac.name].value += ac.value
        else
          seriesPie[ac.name] = {
            name: ac.name,
            value: ac.value,
            selected: selected ? true : false
          }

        selected = true
      })
    }
  }

  let bars = Object.values(series)
  let pie = Object.values(seriesPie)

  let pieTemp = [
    {
      type: 'pie',

      radius: ['60%', '80%'],
      center: ['16%', '50%'],
      data: pie,
      selectedMode: true,
      selectOffset: 3,
      labelLine: {
        show: false
      },
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
        align: 'center',
        formatter: '{b|{b}}\n{c|{c} ({d}%)}',
        rich: {
          b: {
            fontSize: 16,
            lineHeight: 20,
            fontWeight: 400,
            color: '#8D8D8D'
          },
          c: {
            fontSize: 24,
            fontWeight: 700,
            color: '#404040'
          }
        }
      },
      top: '7%',
      select: {
        label: {
          show: true,
          align: 'center',
          formatter: '{b|{b}}\n{c|{c} ({d}%)}',
          rich: {
            b: {
              fontSize: 16,
              lineHeight: 20,
              fontWeight: 400,
              color: '#8D8D8D'
            },
            c: {
              fontSize: 24,
              fontWeight: 700,
              color: '#404040'
            }
          }
        }
      }
    }
  ]

  let result = pieTemp.concat(bars)

  return {
    title: {
      text: 'Action',
      left: 'left',
      show: false
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{a} <br/>{b} : {c}',
      textStyle: {
        fontSize: 14
      }
    },
    legend: {
      show: true,
      orient: 'horizontal',
      top: 0
    },
    color: [
      '#0077B6',
      '#48CAE4',
      '#ADE8F4',
      '#CAF0F8',
      '#FFE89D',
      '#FFC300',
      '#F90',
      '#D27E00',
      '#379DD2',
      '#005490'
    ],
    grid: { left: '36%', right: '7%' },
    xAxis: {
      type: 'category',
      axisTick: { show: false },
      data: data,
      axisLabel: {
        fontSize: 14
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      }
    },

    yAxis: {
      type: 'value',
      axisLine: {
        show: false
      }
    },
    series: result
  }
}

export const advDaily = state => {
  let temps = state.advance
  let data = []
  let daily = []
  let series = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(t => {
      data.push(t.name)

      t.daily_activities.forEach(da => {
        if (!daily.includes(da.name)) daily.push(da.name)

        if (series.hasOwnProperty(da.name)) series[da.name].value.push(da.value)
        else
          series[da.name] = {
            name: da.name,
            value: [da.value]
          }
      })
    })
  }

  let vals = Object.values(series)
  let bars = []

  for (let index = 0; index < data.length; index++) {
    let val = {
      name: data[index],
      type: 'bar',
      label: {
        fontSize: 14
      },
      data: [],
      showBackground: false,
      itemStyle: {
        color: new graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#83bff6' },
          { offset: 0.5, color: '#188df0' },
          { offset: 1, color: '#188df0' }
        ]),
        borderRadius: 2
      },
      emphasis: {
        itemStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#2378f7' },
            { offset: 0.7, color: '#2378f7' },
            { offset: 1, color: '#83bff6' }
          ]),
          borderRadius: 2
        }
      }
    }
    vals.forEach(v => {
      let hsl = v.value[index] ? v.value[index] : 0
      val.data.push(hsl)
    })

    bars.push(val)
  }

  return {
    title: {
      text: 'Daily Activity',
      show: false
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: data
    },
    toolbox: {
      show: false
    },

    calculable: true,
    grid: {
      bottom: '30%',
      left: '5%',
      right: '5%'
    },
    xAxis: {
      type: 'category',
      axisLabel: { interval: 0, rotate: 32, fontSize: 14 },
      data: daily,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      }
    },

    yAxis: {
      type: 'value',
      axisLine: {
        show: false
      }
    },

    series: bars
  }
}

export const listRegion = state => {
  let temp = state.regions
  let data = []

  if (Array.isArray(temp) && temp.length) {
    temp.forEach(t => {
      data.push({
        id: t.id,
        label: t.name.toLowerCase(),
        province: t.province_name.toLowerCase()
      })
    })
  }

  return data
}

export const listCustomers = state => val => {
  let customers = state.geoCustomerSelected

  if (Array.isArray(customers) && customers.length) {
    if (val == 'pb') return customers.sort((a, b) => b.prospek_banks - a.prospek_banks)
    else return customers.sort((a, b) => b.activities - a.activities)
  } else return []
}

export const customerMap = state => val => {
  let value = JSON.parse(JSON.stringify(val))
  let map = value.region > 0 ? 'district_id' : 'province_id'
  let area = value.regions
  let data = state.geoCustomer

  data.forEach(d => {
    if (area.some(o => o.id == d[map])) {
      area.find(o => o.id == d[map]).value += 1
    }
  })

  area.sort(function (a, b) {
    return b.value - a.value
  })

  return area
}

export const pieGroup = state => {
  let data = state.geoCustomerSelected
  let temp = []

  if (Array.isArray(data) && data.length) {
    data.forEach(d => {
      if (d.group) {
        if (temp.some(o => o.name == d.group)) {
          temp.find(o => o.name == d.group).value += 1
        } else {
          temp.push({
            name: d.group,
            value: 1
          })
        }
      }
    })
  }

  temp = temp.sort(() => Math.random() - 0.5)

  let option = {
    title: {
      show: true,
      text: 'Group',
      left: 'center',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return `${params.name}&nbsp; <b>${params.value}</b>`
      }
    },

    series: {
      type: 'pie',
      data: temp,
      radius: '60%',
      itemStyle: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      },
      label: {
        fontSize: 13,
        color: '#dadde1',
        fontWeight: 600,
        alignTo: 'edge',
        formatter: '{b}\n{time|{c}}',
        edgeDistance: 5,
        lineHeight: 27,
        fontFamily: 'monospace',
        rich: {
          time: {
            fontSize: 13,
            color: '#dadde1',
            fontWeight: 600,
            fontFamily: 'monospace'
          }
        }
      },

      color: ['#516b91', '#59c4e6', '#edafda', '#93b7e3', '#a5e7f0', '#cbb0e3'],
      labelLayout: function (params) {
        const isLeft = params.labelRect.x < 580 / 2
        const points = params.labelLinePoints
        // Update the end point.
        points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
        return {
          labelLinePoints: points
        }
      }
    }
  }

  return option
}

export const barCustomerType = state => {
  let data = state.geoCustomerSelected
  let temp = []

  if (Array.isArray(data) && data.length) {
    data.forEach(d => {
      if (temp.some(o => o.name == d.type)) {
        temp.find(o => o.name == d.type).value += 1
      } else {
        temp.push({
          name: d.type,
          value: 1
        })
      }
    })

    temp.sort(function (a, b) {
      return a.value - b.value
    })
  }

  let option = {
    title: {
      show: true,
      text: 'Type',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '15%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: temp.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      data: temp.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        fontWeight: 'bold',
        position: 'insideLeft',
        fontSize: 13
      },
      barGap: '10%',
      barCategoryGap: '20%',
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}

export const barCustomerRating = state => {
  let temp = state.geoCustomerSelected
  let data = []

  if (Array.isArray(temp) && temp.length) {
    temp.forEach(d => {
      if (d.rating) {
        if (data.some(o => o.name == d.rating)) {
          data.find(o => o.name == d.rating).value += 1
        } else {
          data.push({
            name: d.rating,
            value: 1
          })
        }
      }
    })

    data.sort(function (a, b) {
      return a.value - b.value
    })
  }

  let option = {
    title: {
      show: true,
      text: 'Rating',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '5%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: data.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      data: data.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        fontWeight: 'bold',
        position: 'insideLeft',
        fontSize: 13
      },
      barGap: '10%',
      barCategoryGap: '10%',
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}

export const pbMap = state => val => {
  let value = JSON.parse(JSON.stringify(val))
  let map = value.region > 0 ? 'district_id' : 'province_id'
  let area = value.regions
  let data = state.geoPB

  data.forEach(d => {
    if (area.some(o => o.id == d[map])) {
      area.find(o => o.id == d[map]).value += 1
    }
  })

  area.sort(function (a, b) {
    return b.value - a.value
  })

  return area
}

export const pbBarDetail = state => {
  let data = state.geoPBSelected
  let temp = []
  data.forEach(d => {
    let name = d.plan_instrument.instrument.category.name
    if (temp.some(o => o.name == name)) {
      temp.find(o => o.name == name).value += 1
    } else {
      temp.push({
        name: name,
        value: 1
      })
    }
  })

  temp.sort(function (a, b) {
    return a.value - b.value
  })

  let option = {
    title: {
      show: true,
      text: 'Line Business',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '9%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: temp.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      z: 500,
      data: temp.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        position: 'insideLeft',
        fontSize: 13
      },
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}

export const pbBarProbability = state => {
  let data = state.geoPBSelected
  let temp = []
  data.forEach(d => {
    if (d.probability_name) {
      if (temp.some(o => o.name == d.probability_grade)) {
        temp.find(o => o.name == d.probability_grade).value += 1
      } else {
        temp.push({
          name: d.probability_grade,
          value: 1,
          sub: d.probability_name
        })
      }
    }
  })

  temp = temp.sort(() => Math.random() - 0.5)

  let option = {
    title: {
      show: true,
      text: 'Probabilities',
      left: 'center',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return `${params.data.sub} <br /> ${params.name}&nbsp; <b>${params.value}</b>`
      }
    },
    series: {
      type: 'pie',
      data: temp,
      radius: '64%',
      itemStyle: {
        shadowBlur: 7,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      },
      label: {
        fontSize: 13,
        color: '#dadde1',
        fontWeight: 600,
        alignTo: 'edge',
        formatter: 'Grade: {b}\n{time|{d}%}',
        edgeDistance: 5,
        lineHeight: 18,
        fontFamily: 'monospace',
        rich: {
          time: {
            fontSize: 13,
            color: '#dadde1',
            fontWeight: 500,
            fontFamily: 'monospace'
          }
        }
      },

      labelLayout: function (params) {
        const isLeft = params.labelRect.x < 580 / 2
        const points = params.labelLinePoints
        // Update the end point.
        points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
        return {
          labelLinePoints: points
        }
      }
    }
  }

  return option
}

export const piePBStatus = state => {
  let temp = state.geoPBSelected
  let data = []

  temp.forEach(d => {
    if (d.status) {
      if (data.some(o => o.name == d.status)) {
        data.find(o => o.name == d.status).value += 1
      } else {
        data.push({
          name: d.status,
          value: 1
        })
      }
    }
  })

  data.sort(function (a, b) {
    return a.value - b.value
  })

  let option = {
    title: {
      show: true,
      text: 'Status',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '10%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: data.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      data: data.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        position: 'insideLeft',
        fontSize: 13
      },
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}

export const piePBPrincipal = state => {
  let temp = state.geoPBSelected
  let data = []

  if (Array.isArray(temp) && temp.length) {
    temp.forEach(d => {
      let brand = d.plan_instrument.instrument.brand.name

      if (data.some(o => o.name == brand)) {
        data.find(o => o.name == brand).value += 1
      } else {
        data.push({
          name: brand,
          value: 1
        })
      }
    })
  }

  data = data.sort(() => Math.random() - 0.5)

  return {
    title: {
      show: true,
      text: 'Principal',
      left: 'center',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    series: {
      type: 'pie',
      data: data,
      radius: '64%',
      itemStyle: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      },
      label: {
        fontSize: 13,
        color: '#dadde1',
        fontWeight: 600,
        alignTo: 'edge',
        formatter: '{b}\n{time|{d}%}',
        edgeDistance: 5,
        lineHeight: 18,
        fontFamily: 'monospace',
        rich: {
          time: {
            fontSize: 13,
            color: '#dadde1',
            fontWeight: 600,
            fontFamily: 'monospace'
          }
        }
      }
    }
  }
}

export const instrumentMap = state => val => {
  let value = JSON.parse(JSON.stringify(val))
  let map = value.region > 0 ? 'district_id' : 'province_id'
  let area = value.regions
  let data = state.geoInstrument

  data.forEach(d => {
    if (area.some(o => o.id == d[map])) {
      area.find(o => o.id == d[map]).value += 1
    }
  })

  area.sort(function (a, b) {
    return b.value - a.value
  })

  return area
}

export const instrumentCategory = state => {
  let data = state.geoInstrumentSelected
  let temp = []
  data.forEach(d => {
    let name = d.category_name
    if (temp.some(o => o.name == name)) {
      temp.find(o => o.name == name).value += 1
    } else {
      temp.push({
        name: name,
        value: 1
      })
    }
  })

  temp.sort(function (a, b) {
    return a.value - b.value
  })

  let option = {
    title: {
      show: true,
      text: 'Line Business',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '9%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: temp.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      z: 500,
      data: temp.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        fontWeight: 'bold',
        position: 'insideLeft',
        fontSize: 13
      },
      barGap: '10%',
      barCategoryGap: '20%',
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}
export const instrumentSegment = state => {
  let data = state.geoInstrumentSelected
  let temp = []
  data.forEach(d => {
    let name = d.segment_name
    if (temp.some(o => o.name == name)) {
      temp.find(o => o.name == name).value += 1
    } else {
      temp.push({
        name: name,
        value: 1
      })
    }
  })

  temp.sort(function (a, b) {
    return a.value - b.value
  })

  let option = {
    title: {
      show: true,
      text: 'Segment',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '9%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: temp.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      z: 500,
      data: temp.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        fontWeight: 'bold',
        position: 'insideLeft',
        fontSize: 13
      },
      barGap: '10%',
      barCategoryGap: '20%',
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}

export const instrumentBrand = state => {
  let data = state.geoInstrumentSelected
  let temp = []
  data.forEach(d => {
    let name = d.brand_name
    if (temp.some(o => o.name == name)) {
      temp.find(o => o.name == name).value += 1
    } else {
      temp.push({
        name: name,
        value: 1
      })
    }
  })

  temp.sort(function (a, b) {
    return a.value - b.value
  })

  let option = {
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return `${params.name}&nbsp; <b>${params.value}</b>`
      }
    },
    series: [
      {
        type: 'pie',
        radius: ['42%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        },
        label: {
          fontSize: 13,
          color: '#dadde1',
          fontWeight: 600,
          alignTo: 'edge',
          formatter: '{b}\n{time|{d}%}',
          edgeDistance: 5,
          lineHeight: 18,
          fontFamily: 'monospace',
          rich: {
            time: {
              fontSize: 13,
              color: '#dadde1',
              fontWeight: 600,
              fontFamily: 'monospace'
            }
          }
        },
        labelLayout: function (params) {
          const isLeft = params.labelRect.x < 580 / 2
          const points = params.labelLinePoints
          // Update the end point.
          points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
          return {
            labelLinePoints: points
          }
        },
        data: temp
      }
    ]
  }

  return option
}

export const instrumentType = state => {
  let data = state.geoInstrumentSelected
  let temp = []
  data.forEach(d => {
    let name = d.instrument_name
    if (temp.some(o => o.name == name)) {
      temp.find(o => o.name == name).value += 1
    } else {
      temp.push({
        name: name,
        value: 1
      })
    }
  })

  temp.sort(function (a, b) {
    return a.value - b.value
  })

  let option = {
    title: {
      show: true,
      text: 'Instrument',
      textStyle: {
        color: '#dcdcdc'
      }
    },
    grid: {
      top: '9%',
      bottom: 0,
      right: 0,
      left: 0
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      show: false,
      data: temp.map(function (item) {
        return item.name
      })
    },
    series: {
      type: 'bar',
      z: 500,
      data: temp.map(function (item) {
        return item.value
      }),
      label: {
        show: true,
        formatter: '{c} {b}',
        fontWeight: 'bold',
        position: 'insideLeft',
        fontSize: 13
      },
      barGap: '10%',
      barCategoryGap: '20%',
      itemStyle: {
        color: '#1d2835bf',
        borderRadius: 4
      }
    }
  }

  return option
}
